import React, { useState } from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import styles from './ApprovalToggle.module.css';

interface ApprovalToggleProps {
  isApproved: boolean;
  onToggle: (newState: boolean) => Promise<void>;
  disabled?: boolean;
}

export const ApprovalToggle: React.FC<ApprovalToggleProps> = ({
  isApproved,
  onToggle,
  disabled = false,
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const handleClick = async () => {
    setIsLoading(true);
    try {
      await onToggle(!isApproved);
    } catch (error) {
      console.error('Error toggling approval:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div
      className={`${styles.approvalToggle} ${isApproved ? styles.approved : styles.notApproved} ${isLoading ? styles.loading : ''}`}
      onClick={handleClick}
      style={{ 
        cursor: (disabled || isLoading) ? 'not-allowed' : 'pointer',
        opacity: (disabled || isLoading) ? 0.5 : 1
      }}
      title={isApproved ? 'Click to unapprove' : 'Click to approve'}
    >
      {isApproved ? (
        <CheckCircle className={styles.toggleIcon} />
      ) : (
        <XCircle className={styles.toggleIcon} />
      )}
    </div>
  );
};

